import { render } from "./registerExpense.vue?vue&type=template&id=26a2a9a0&scoped=true"
import script from "./registerExpense.vue?vue&type=script&lang=js"
export * from "./registerExpense.vue?vue&type=script&lang=js"

import "./registerExpense.vue?vue&type=style&index=0&id=26a2a9a0&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/itibo/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a2a9a0"]])

export default __exports__